'use client'

import { useEffect, useState } from 'react'

type MobileOs = 'android' | 'ios' | 'other'

export const useMobileOS = (): MobileOs => {
  const [mobileOs, setMobileOs] = useState<MobileOs>('other')

  useEffect(() => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      setMobileOs('ios')
    }

    // Check for Android
    if (/android/i.test(navigator.userAgent)) {
      setMobileOs('android')
    }
  }, [])

  return mobileOs
}
